import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_EMPLOYEE_DETAIL,
  GET_EMPLOYEES,
  GET_EMPLOYEE_COMMENTS,
  GET_AUTH_USER,
  UPDATE_EMPLOYEE,
  DELETE_EMPLOYEE,
} from "./actionTypes"

import {
  deleteEmployeeFail,
  deleteEmployeeSuccess,
  getAuthUsersFail,
  getAuthUsersSuccess,
  getEmployeeDetailFail,
  getEmployeeDetailSuccess,
  getEmployeesFail,
  getEmployeesSuccess,
  updateEmployeeFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getEmployees,
  getEmployeeDetail,
  // getEmployeeComents as getEmployeeComentsApi, 
  getAuthUsersResponse,
  updateEmployees,
  deleteEmployeesURL
} from "helpers/fakebackend_helper"

function* fetchEmployees(props) {
  try {
    const response = yield call(getEmployees, props.payload)
    yield put(getEmployeesSuccess(response))
  } catch (error) {
    yield put(getEmployeesFail(error))
  }
}

function* updateEmployeesFun(props) {
  try {
    const response = yield call(updateEmployees, props.payload)
    yield put(updateEmployeeSuccess(response))
  } catch (error) {
    yield put(updateEmployeeFail(error))
  }
}

function* fetchAuthUsers() {
  
  try {
    const response = yield call(getAuthUsersResponse) 
    yield put(getAuthUsersSuccess(response))
  } catch (error) {
    yield put(getAuthUsersFail(error))
  }
}

function* fetchEmployeeDetail({ employeeId }) {
  try {
    const response = yield call(getEmployeeDetail, employeeId)
    yield put(getEmployeeDetailSuccess(response))
  } catch (error) {
    yield put(getEmployeeDetailFail(error))
  }
}
function* deleteEmployees(employeeId ) {
  try {
    const response = yield call(deleteEmployeesURL, employeeId.payload)
    yield put(deleteEmployeeSuccess(response))
  } catch (error) {
    yield put(deleteEmployeeFail(error))
  }
}

function* employeesSaga() {
  yield takeEvery(GET_EMPLOYEES, fetchEmployees)
  yield takeEvery(GET_EMPLOYEE_DETAIL, fetchEmployeeDetail)
  yield takeEvery(UPDATE_EMPLOYEE, updateEmployeesFun)
  yield takeEvery(DELETE_EMPLOYEE,deleteEmployees)
  // yield takeEvery(GET_AUTH_USER, fetchAuthUsers)
}

export default employeesSaga
